import createCachedSelector from 're-reselect';

import type { BettingEntitiesSelectors } from 'app/lib/betting/betting-entities';
import { orderByGlobalPriority } from 'app/lib/grid';
import { sortByPriority } from 'app/lib/sortByPriorityImmutableData';
import { currentLocation } from 'app/modules/Navigation/selectors';

export default (
  matches: BettingEntitiesSelectors['matches'],
  getStagesFromTournamentsSelector: BettingEntitiesSelectors['getStagesFromTournamentsSelector'],
) => {
  return createCachedSelector(
    matches,
    getStagesFromTournamentsSelector,
    (state) => currentLocation(state).tournamentStageId,
    (matchesById, tournamentStages, stageId) => {
      if (!tournamentStages) {
        return new Map();
      }

      if (stageId) {
        const tournamentStage = tournamentStages.get(stageId);

        if (!tournamentStage) {
          return new Map();
        }

        return new Map([[
          stageId,
          new Set(orderByGlobalPriority(matchesById, [...tournamentStage.matchIds])),
        ]]);
      }

      const sortedStages = sortByPriority(tournamentStages) as typeof tournamentStages;

      return sortedStages.reduce((map, stage) => {
        return map
          .set(stage.id, new Set(orderByGlobalPriority(matchesById, [...stage.matchIds])));
      }, new Map());
    },
  )((_state, tournamentId) => tournamentId);
};
